import { FunctionComponent, createContext, useContext } from "react";
import { ModalContextData } from "@idw-types/context";

export const ModalContext = createContext<ModalContextData>(undefined);

type ModalContextProviderProps = { data: ModalContextData, children: any };

const ModalContextProvider: FunctionComponent<ModalContextProviderProps> = ({ data, children }) => (
    <ModalContext.Provider value={data}>{children}</ModalContext.Provider>
);

export const Consumer = ModalContext.Consumer;
export const Provider = ModalContextProvider;

export const useModalContext = () => useContext(ModalContext);